//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
var LABEL_MAP = {
  'one': 'https://p0.meituan.net/myvideodistribute/fd841a9541d9472b9f9bb6a1e82a374927898.png',
  'two': 'https://p0.meituan.net/myvideodistribute/afb1a2551153dd0e6f7f9a5e71854a0b34439.png',
  'three': 'https://p0.meituan.net/myvideodistribute/0bb67adef6bf18429152b6f656d632e735562.png',
  'four': 'https://p0.meituan.net/myvideodistribute/1bcd96d3b1b7b3f3ca962f6b74145a0d48185.png'
};
export default {
  name: 'see-label',
  props: {
    relievedTagVO: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      labelBg: ''
    };
  },
  mounted: function mounted() {
    this.getHeight();
  },
  methods: {
    getHeight: function getHeight() {
      var tagDiv = this.$refs.tabList;
      var styleLabel = '';
      if (tagDiv) {
        if (tagDiv.clientHeight < 30) {
          styleLabel = 'one';
        } else if (tagDiv.clientHeight < 50) {
          styleLabel = 'two';
        } else if (tagDiv.clientHeight < 70) {
          styleLabel = 'three';
        } else {
          styleLabel = 'four';
        }
      }
      this.labelBg = LABEL_MAP[styleLabel];
    },
    onLabelClick: function onLabelClick(url) {
      Drip.redirect(url, {
        _blank: true
      });
    }
  }
};